import requests from '../request'

const unitInfo = localStorage.getItem('unitInfo')
let unitId
if (unitInfo && unitInfo !== null) {
	unitId = JSON.parse(unitInfo).strGuid
}
const userId = localStorage.getItem('userId')
const ids = `userId=${userId}&unitId=${unitId}`


// 后台管理(事件管理) 事件获取组织机构(单位)
export const eventGetAllUnitAPI = (params) => {
	return requests({
		url: '/api/base/event/getAllUnit',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件管理) 事件获取人员
export const eventGetUnitUserAPI = (params) => {
	return requests({
		url: '/api/base/event/getUnitUser',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件管理) 事件接报(提交)
export const addEventAPI = (data) => {
	return requests({
		url: '/api/base/event/add',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

// 后台管理(事件管理) 修改事件 事件发布成功 修改字段(publish)   
export const eventUpdateAPI = (data) => {
	return requests({
		url: '/api/base/event/update',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件管理) 删除事件
export const deleteEventAPI = (params) => {
	return requests({
		url: '/api/base/event/delete',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件管理) 启动流程(发布)
export const manageStartProcessInstanceAPI = (data) => {
	return requests({
		url: '/api/flowManage/startProcessInstance',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}


// 后台管理(待办列表) 列表
export const apiflowManageListMyRuntimeTask = (data) => {
	return requests({
		url: '/api/flowManage/listMyRuntimeTask',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(待办列表) 列表
export const eventReportListMyRuntimeTaskAPI = (data) => {
	return requests({
		url: '/api/event/report/listMyRuntimeTask',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

// 后台管理(事件流程) 任务流程轴
export const flowManageHistoryRuntimeTaskAPI = (params) => {
	return requests({
		url: '/api/flowManage/historyRuntimeTask',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程) 代办任务办理时间轴
export const eventReportHistoryRuntimeTaskAPI = (params) => {
	return requests({
		url: '/api/event/report/historyRuntimeTask',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程) 历史任务办理时间轴
export const eventReportHistoryTaskAPI = (params) => {
	return requests({
		url: '/api/event/report/historyTask',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

// 后台管理(事件流程) 获取用户任务流出线	
export const flowManageListOutgoingFlowsAPI = (params) => {
	return requests({
		url: '/api/flowManage/listOutgoingFlows',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程) 办理任务	
export const flowManageCompleteTaskAPI = (data) => {
	return requests({
		url: '/api/flowManage/completeTask',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

// 后台管理(事件流程) 调度 任务节点列表下拉选
export const listUserTaskByProcessDefinitionIdAPI = (params) => {
	return requests({
		url: '/api/flowManage/listUserTaskByProcessDefinitionId',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程) 调度确定
export const flowManageJumpAPI = (data) => {
	return requests({
		url: '/api/flowManage/jump',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程) 重置处置人
export const flowManageSetAssigneeAPI = (data) => {
	return requests({
		url: '/api/flowManage/setAssignee',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

// 后台管理(事件流程) 获取事件基础信息(表单)
export const eventGetAPI = (params) => {
	return requests({
		url: '/api/base/event/get',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程) 获取事件扩展信息(表单)
export const eventExpandGetEventExpandAPI = (params) => {
	return requests({
		url: '/api/base/eventExpand/getEventExpand',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}


// 后台管理(事件流程) 表单保存
export const eventExpandUpdateEventExpandAPI = (data) => {
	return requests({
		url: '/api/base/eventExpand/updateEventExpand',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程--事件接报录入) 事件编号生成
export const resetSerialNumberGeneratorAPI = (params) => {
	return requests({
		url: '/api/base/eventExpand/resetSerialNumberGenerator',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}



// 后台管理(事件流程--匹配相关资源) 所有资源类型
export const resourceNewTypesAPI = (params) => {
	return requests({
		url: '/api/resourceNew/types',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程--匹配相关资源) 获取批次编号
export const eventBindResourceGetResourceBatchAPI = (params) => {
	return requests({
		url: '/api/base/eventBindResource/getResourceBatch',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程--匹配相关资源) 处置事件资源列表
export const eventBindResourceGetBusEventBindResourceTypesAPI = (params) => {
	return requests({
		url: '/api/base/eventBindResource/getBusEventBindResourceTypes',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(事件流程--资源调度) 事件资源类型查询资源
export const eventBindResourceGetBusEventBindResourcesAPI = (params) => {
	return requests({
		url: '/api/base/eventBindResource/getBusEventBindResources',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}


// 后台管理(事件流程--匹配相关资源) 新增事件关联资源
export const eventBindResourceSaveBusEventBindResourceTypeAPI = (data) => {
	return requests({
		url: '/api/base/eventBindResource/saveBusEventBindResourceType',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

// 后台管理(事件流程--匹配相关资源) 删除事件关联资源类型
export const eventBindResourceDeleteBusEventBindResourceTypeAPI = (params) => {
	return requests({
		url: '/api/base/eventBindResource/deleteBusEventBindResourceType',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}




// 后台管理(事件流程--资源调度) 保存事件资源
export const eventBindResourceSaveBusEventBindResourceAPI = (data) => {
	return requests({
		url: '/api/base/eventBindResource/saveBusEventBindResource',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}


// 后台管理(事件流程--资源调度) 保存事件资源(回显)
export const eventBindResourceGetBusEventBindResourcesByEventIdAPI = (params) => {
	return requests({
		url: '/api/base/eventBindResource/getBusEventBindResourcesByEventId',
		method: 'GET',
		params,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}




// 后台管理(历史任务) 历史任务列表
export const flowManageListMyHistoryTaskAPI = (data) => {
	return requests({
		url: '/api/flowManage/listMyHistoryTask',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 后台管理(历史任务) 历史任务列表
export const eventReportListMyHistoryTask = (data) => {
	return requests({
		url: '/api/event/report/listMyHistoryTask',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}




// 事件中心接口

/*流程监控  事件接报列表查询*/
export const listEventReportAPI = (data, pageNum, pageSize) => {
	return requests({
		url: '/api/info/report/listEventReportByUnit?pageNum=' + pageNum + '&pageSize=' + pageSize,
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

/*事件类型管理 查询列表*/
export const listEventTypeAPI = (data, pageNum, pageSize) => {
	return requests({
		url: '/api/event/type/listEventType?pageNum=' + pageNum + '&pageSize=' + pageSize,
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

/*流程监控  领导督察*/
export const getEventReportByIdAPI = (data, pageNum, pageSize) => {
	return requests({
		url: '/api/info/report/getEventReportById?id=' + data,
		method: 'POST',
		// data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

/*待办任务  查询我的待办任务列表*/
export const listMyRuntimeTaskAPI = (pageNum, pageSize, eventCategory, assignee) => {
	return requests({
		url: '/api/info/report/listMyRuntimeTask?pageNum=' + pageNum + '&pageSize=' + pageSize +
			'&eventCategory=' +
			eventCategory + '&assignee=' + assignee,
		method: 'POST',
		// data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

/*待办任务  查询我的待办任务列表*/
export const listMyRuntimeTaskv2API = (pageNum, pageSize, eventCategory, assignee) => {
	return requests({
		url: '/api/info/report/listMyRuntimeTask?pageNum=' + pageNum + '&pageSize=' + pageSize +
			'&eventCategory=' +
			eventCategory + '&assignee=' + assignee,
		method: 'get',
		// data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 事件下派 任务执行人员 执行任务
export const finishAssignTaskAPI = (data) => {
	return requests({
		url: '/api/assign/task/finishAssignTask',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 事件下派 获取组织机构
export const listUnitAPI = (data) => {
	return requests({
		url: '/api/assign/task/listUnit',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
// 事件下派 获取组织机构
export const listBaseUserByUnitCodeAPI = (data) => {
	return requests({
		url: '/api/assign/task/listBaseUserByUnitCode?unitCodes=' + objData,
		method: 'POST',
		// data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
/*流程监控  批示申请*/
export const addEventTaskAnnotationAPI = (data) => {
	return requests({
		url: '/api/info/report/addEventTaskAnnotation',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

/*代办列表  批示详情*/
export const listEventTaskAnnotationsDetailsAPI = (data, pageNum, pageSize) => {
	return requests({
		url: '/api/info/report/listEventTaskAnnotation?pageNum=' + pageNum + '&pageSize=' + pageSize,
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}


/*历史任务  查询我的历史任务列表*/
export const listMyHistoryTaskAPI = (objData) => {
	return requests({
		url: '/api/info/report/listMyHistoryTask?taskName=' + objData.taskName + '&processDefinitionName=' +
			objData
			.processDefinitionName +
			'&pageNum=' + objData.pageNum + '&pageSize=' + objData.pageSize + '&assignee=' + objData
			.assignee,
		method: 'POST',
		data: objData,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

/*事件类型管理 新增事件类型 */

export const addEventTypeAPI = (data) => {
	return requests({
		url: '/api/info/type/addEventType',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
/*事件类型管理  修改事件类型*/
export const updateEventTypeAPI = (data) => {
	return requests({
		url: '/api/info/type/updateEventType',
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
/*事件类型管理  删除事件类型*/
export const deleteEventTypeAPI = (data) => {
	return requests({
		url: '/api/info/type/deleteEventType?strGuid=' + data.strGuid,
		method: 'POST',
		data,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
/*事件类型管理 查询列表*/
export const selectPageListAPIEvent = (objData, pageNum, pageSize) => {
	return requests({
		url: '/api/event/type/selectPageList?pageNum=' + pageNum + '&pageSize=' + pageSize,
		method: 'POST',
		data: objData,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}

/*流量监控  详情*/
export const historyTaskDetailsAPI = (objData) => {
	return requests({
		url: '/api/info/report/historyTask?businessKey=' + objData,
		method: 'get',
		data: objData,
		headers: {
			'Contont-type': 'application/json'
		}
	})
}
